import Vue from "vue";

/**
 * 长安自定义指令
 */
export const LongTouch = Vue.directive("LongTouch", {
  bind: (el, binding) => {
    let {
      handleLongTouch,
      handleLongTouchEnd,
      data,
      time,
      opacity,
      touchmove,
    } = binding.value;
    let $time = time || 100;
    var pressTimer = null;
    // 定义长按开始的处理函数
    const start = (e) => {
      if (e.type === "click" && e.button !== 0 && e.type === "mousedown") {
        return;
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          if (opacity) {
            el.style.opacity = opacity;
          }
          handleLongTouch && handleLongTouch(e, data, el);
        }, $time);
      }
    };
    // 定义长按结束的处理函数
    const cancel = (e) => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
        handleLongTouchEnd && handleLongTouchEnd(e, data);
      }
    };

    el.addEventListener("mousedown", cancel);
    el.addEventListener("touchstart", start);
    el.addEventListener("click", cancel);
    touchmove && el.addEventListener("touchmove", cancel);
    el.addEventListener("mouseout", cancel);
    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);
  },
});



// WEBPACK FOOTER //
// ./src/directives/longTouch.js